// extracted by mini-css-extract-plugin
export default {"Container":"wTmnog_tUQbTjArglNkf","Status":"Iq9Ou8eOX05eK0XXamY0","UninstallButton":"Wkjh7xftzFQRfcbkl2X8"};